<!-- <pre> {{ f.value | json }} </pre>
<pre> {{ chapter | json }} </pre> -->

<ng-container *ngIf="chapter">
  <div class=" block font-medium mt-0">Chương {{ +chapter.position + 1 }}</div>
  <div class="text-xs f6-ns font-normal text-gray-500 measure lh-copy my-0">
    <span>{{chapter.published ? 'Đã xuất bản' : 'Đang nháp' }}</span>
    <span> ({{ chapter.content && chapter.content.length ? convertToPlain(chapter.content).split(' ').length : 0 }} từ) </span>
  </div>
</ng-container>